module.exports = __webpack_public_path__ + "img/walk.be5030ca.webp";